import React from "react";
import PropTypes from "prop-types";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";

function CurrencyTextField({ errorMessage, type, maxValue, maxValueHelperText, minValue, minValueHelperText, label, ...props }) {
    let error = false;
    let helperText = "";
    const value = parseFloat(props.value);
    if ((minValue || minValue == 0) && value < minValue) {
        error = true;
        helperText = minValueHelperText || null;
    }
    if (maxValue && value > maxValue) {
        error = true;
        helperText = maxValueHelperText || null;
    }

    const fieldProps = {};
    if (label) {
        fieldProps.label = label;
    }

    return (
        <TextField
            style={{ width: "100%" }}
            {...fieldProps}
            error={error}
            helperText={errorMessage || helperText}
            InputProps={{
                startAdornment: <InputAdornment position="start">{type.toLowerCase() === "percentage" ? "%" : "$"}</InputAdornment>,
            }}
            inputProps={{
                ...props,
            }}
        />
    );
}

CurrencyTextField.propTypes = {
    label: PropTypes.string,
    minValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    minValueHelperText: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

CurrencyTextField.defaultProps = {
    label: null,
    minValue: null,
    minValueHelperText: null,
};

export default CurrencyTextField;
